import React from 'react';
import { WarningBar } from '@/shared/components/ui';

interface FunnelNoUsersBannerProps {
  /** Abre o drawer de configuração do funil direto na aba Usuários */
  onAssignUsers: () => void;
  /** CTA visível apenas para quem pode editar funis (funnels.update) */
  canAssignUsers: boolean;
}

/**
 * Barra de aviso exibida no CRM quando o funil selecionado não tem nenhum
 * usuário associado (`funnels-users` vazio = D-context-gate inativo): os
 * leads do funil não aparecem nas listagens e a distribuição automática não
 * roda. Sem dismiss — persiste até associarem pelo menos 1 usuário
 * (`hasUsers` vira `true` e a barra sai sozinha).
 */
export const FunnelNoUsersBanner: React.FC<FunnelNoUsersBannerProps> = ({
  onAssignUsers,
  canAssignUsers,
}) => (
  <WarningBar
    data-testid="crm-funnel-no-users-banner"
    message="Este funil não possui usuários associados — os leads não serão exibidos e a distribuição automática não atua."
    action={
      canAssignUsers
        ? {
            label: 'Associar usuários',
            onClick: onAssignUsers,
            'data-testid': 'crm-funnel-no-users-assign',
          }
        : undefined
    }
  />
);
